module.exports = __webpack_public_path__ + "media/images/about/history/president-5-201237dacd22b56f3e51dce1f1bc4880.png";